document.documentElement.classList.remove('no-js');

/* ---------- Age gate ---------- */
(function () {
  var gate = document.getElementById('AgeGate');
  if (!gate) return;
  var KEY = 'thca_age_verified';
  try {
    if (localStorage.getItem(KEY) === 'yes') {
      gate.setAttribute('data-hidden', '');
      gate.style.display = 'none';
    }
  } catch (e) {}

  gate.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-age-confirm]');
    if (!btn) return;
    if (btn.getAttribute('data-age-confirm') === 'yes') {
      try { localStorage.setItem(KEY, 'yes'); } catch (e) {}
      gate.style.display = 'none';
    }
  });
})();

/* ---------- Scroll reveal ---------- */
(function () {
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el) { io.observe(el); });
})();

/* ---------- Sticky header state ---------- */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var ticking = false;
  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > 12);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
})();

/* ---------- Mobile nav ---------- */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;
  function setOpen(isOpen) {
    nav.classList.toggle('is-open', isOpen);
    document.body.classList.toggle('nav-open', isOpen);
    document.body.classList.toggle('is-locked', isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
  }
  toggle.addEventListener('click', function () {
    setOpen(!nav.classList.contains('is-open'));
  });
  nav.addEventListener('click', function (e) {
    if (e.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
  });
})();

/* ---------- Product gallery thumbs ---------- */
(function () {
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImg = document.getElementById('ProductMainImage');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var fullSet = thumb.getAttribute('data-srcset');
      var alt = thumb.getAttribute('data-alt');
      if (mainImg.getAttribute('src') === full) return;
      mainImg.classList.add('is-fading');
      var swap = new Image();
      swap.onload = function () {
        mainImg.src = full;
        // srcset outranks src in the browser's source selection — it must be
        // swapped (or dropped) too, or the visible image never changes.
        if (fullSet) { mainImg.srcset = fullSet; } else { mainImg.removeAttribute('srcset'); }
        if (alt) mainImg.alt = alt;
        requestAnimationFrame(function () { mainImg.classList.remove('is-fading'); });
      };
      swap.src = full;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
  if (thumbs[0]) thumbs[0].classList.add('is-active');
})();

/* ---------- Variant selection ---------- */
(function () {
  var dataEl = document.getElementById('ProductVariantData');
  var hidden = document.getElementById('ProductSelectedVariant');
  var pickers = document.querySelectorAll('.variant-picker');
  if (!dataEl || !hidden || !pickers.length) return;
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
  if (!variants.length) return;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function selectedValues() {
    return Array.prototype.map.call(pickers, function (p) {
      var checked = p.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var match = true;
      for (var k = 0; k < vals.length; k++) {
        if (vals[k] !== null && String(opts[k]) !== String(vals[k])) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Honest per-gram economics: tier title -> grams. Unknown titles hide the line.
     Savings are measured against the 3.5g eighth (the priciest gram) so bigger
     sizes read as the bulk discount they are. */
  var GRAMS_PER_TIER = { '3.5g': 3.5, '7g': 7, '14g': 14, '28g': 28 };

  function updateEconLine(v) {
    var econ = document.querySelector('[data-variant-econ]');
    if (!econ) return;
    var grams = GRAMS_PER_TIER[v.title];
    var baseVariant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === '3.5g') { baseVariant = variants[i]; break; }
    }
    if (!grams || !baseVariant || !baseVariant.price || !v.available) {
      econ.hidden = true;
      return;
    }
    var perGram = v.price / grams;
    var basePerGram = baseVariant.price / GRAMS_PER_TIER['3.5g'];
    var savePct = Math.round((1 - perGram / basePerGram) * 100);
    econ.textContent = '≈ ' + money(perGram) + ' / g' + (savePct > 0 ? ' — save ' + savePct + '% vs eighths' : '');
    econ.hidden = false;
  }

  function update() {
    var v = findVariant(selectedValues());
    if (!v) return;
    hidden.value = v.id;
    var priceEl = document.querySelector('.product-detail__price .mono');
    if (priceEl) priceEl.textContent = money(v.price);
    var submit = document.querySelector('[data-add-to-cart-form]');
    if (submit) {
      submit.disabled = !v.available;
      submit.textContent = v.available ? 'Add to bag — ' + money(v.price) : 'Sold out';
    }
    var barPrice = document.querySelector('.buybar__info .mono');
    if (barPrice) barPrice.textContent = money(v.price);
    var barBtn = document.querySelector('[data-buybar-add]');
    if (barBtn) {
      barBtn.disabled = !v.available;
      barBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
    }
    updateEconLine(v);
  }

  Array.prototype.forEach.call(pickers, function (p) {
    p.addEventListener('change', update);
  });
  update();
})();

/* ---------- Quantity steppers ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var stepper = (minus || plus).closest('.qty-stepper');
    var input = stepper && stepper.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    input.value = Math.max(parseInt(input.min, 10) || 1, val + (plus ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* ---------- Cart drawer ---------- */
var CartDrawer = (function () {
  var drawer = document.getElementById('CartDrawer');
  var itemsEl = drawer && drawer.querySelector('[data-cart-items]');
  var emptyEl = drawer && drawer.querySelector('[data-cart-empty]');
  var footerEl = drawer && drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer && drawer.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderShipProgress(cart) {
    var prog = drawer && drawer.querySelector('[data-ship-progress]');
    if (!prog) return;
    if (cart.item_count === 0) { prog.hidden = true; return; }
    var threshold = parseInt(prog.getAttribute('data-threshold'), 10) || 7500;
    var label = prog.querySelector('[data-ship-label]');
    var fill = prog.querySelector('[data-ship-fill]');
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    prog.hidden = false;
    if (fill) fill.style.width = pct + '%';
    if (label) {
      label.textContent = remaining > 0
        ? "You're " + moneyFormat(remaining) + ' away from free shipping'
        : 'Free shipping unlocked';
    }
    prog.classList.toggle('is-unlocked', remaining <= 0);
  }

  function render(cart) {
    if (!drawer) return;
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    renderShipProgress(cart);

    if (cart.item_count === 0) {
      emptyEl.style.display = 'block';
      footerEl.hidden = true;
      itemsEl.innerHTML = '';
      return;
    }

    emptyEl.style.display = 'none';
    footerEl.hidden = false;
    subtotalEl.textContent = moneyFormat(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      return '' +
        '<li class="cart-drawer__item" data-key="' + item.key + '">' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
          '<div class="cart-drawer__item-info">' +
            '<h4>' + escapeHtml(item.product_title) + '</h4>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<span class="cart-drawer__variant mono">' + escapeHtml(item.variant_title) + '</span>'
              : '') +
            '<span class="mono">' + moneyFormat(item.final_line_price) + '</span>' +
            '<div class="cart-drawer__item-controls">' +
              '<span class="drawer-qty">' +
                '<button type="button" data-drawer-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span class="mono" data-drawer-count>' + item.quantity + '</span>' +
                '<button type="button" data-drawer-qty="1" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<button type="button" class="drawer-remove" data-drawer-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    }).join('');
  }

  var changing = false;
  function change(key, qty) {
    if (changing) return;
    changing = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { refresh(); })
      .finally(function () { changing = false; });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-drawer-qty]');
      var removeBtn = e.target.closest('[data-drawer-remove]');
      if (!qtyBtn && !removeBtn) return;
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      if (removeBtn) { change(key, 0); return; }
      var countEl = line.querySelector('[data-drawer-count]');
      var current = parseInt(countEl ? countEl.textContent : '1', 10) || 1;
      change(key, Math.max(0, current + parseInt(qtyBtn.getAttribute('data-drawer-qty'), 10)));
    });
  }

  function refresh() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  var lastFocus = null;

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); refresh(); open(); }
    if (e.target.closest('[data-cart-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
  });

  refresh();
  return { refresh: refresh, open: open, close: close };
})();

/* ---------- Add to cart (quick add + product form) ---------- */
(function () {
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (btn) { btn.textContent = 'Added ✓'; }
        CartDrawer.refresh();
        CartDrawer.open();
      })
      .catch(function () {
        if (btn) btn.textContent = 'Try again';
      })
      .finally(function () {
        if (btn) {
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalText;
          }, 1200);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest('[data-add-to-cart]');
    if (quickAdd) {
      e.preventDefault();
      addToCart(quickAdd.getAttribute('data-variant-id'), 1, quickAdd);
    }
  });

  var productForm = document.querySelector('[data-add-to-cart-form]');
  if (productForm) {
    productForm.closest('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = document.getElementById('ProductSelectedVariant');
      var qtyInput = document.getElementById('Quantity');
      addToCart(variantInput ? variantInput.value : null, qtyInput ? parseInt(qtyInput.value, 10) : 1, productForm);
    });
  }
})();

/* ---------- Cart page: steppers submit the update form ---------- */
(function () {
  var form = document.getElementById('CartPageForm');
  if (!form) return;
  form.addEventListener('change', function (e) {
    if (e.target.matches('input[name="updates[]"]')) form.submit();
  });
})();

/* ---------- Gallery lightbox ---------- */
(function () {
  var box = document.getElementById('Lightbox');
  var dataEl = document.getElementById('LightboxData');
  if (!box || !dataEl) return;
  var images = [];
  try { images = JSON.parse(dataEl.textContent); } catch (e) {}
  if (!images.length) return;

  var img = document.getElementById('LightboxImage');
  var counter = box.querySelector('[data-lightbox-counter]');
  var idx = 0;
  var lastFocus = null;

  function show(i) {
    idx = (i + images.length) % images.length;
    img.src = images[idx];
    if (counter) counter.textContent = (idx + 1) + ' / ' + images.length;
  }

  function open(i) {
    lastFocus = document.activeElement;
    show(i);
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var closeBtn = box.querySelector('.lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function currentIndex() {
    var main = document.getElementById('ProductMainImage');
    if (!main) return 0;
    var base = main.src.split('?')[0];
    for (var k = 0; k < images.length; k++) {
      if (images[k].split('?')[0] === base) return k;
    }
    return 0;
  }

  var opener = document.querySelector('[data-lightbox-open]');
  if (opener) {
    opener.addEventListener('click', function () { open(currentIndex()); });
    opener.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(currentIndex()); }
    });
  }

  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-lightbox-close]')) { close(); return; }
    if (e.target.closest('[data-lightbox-prev]')) show(idx - 1);
    if (e.target.closest('[data-lightbox-next]')) show(idx + 1);
  });

  document.addEventListener('keydown', function (e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(idx - 1);
    if (e.key === 'ArrowRight') show(idx + 1);
  });
})();

/* ---------- Sticky mobile buy bar ---------- */
(function () {
  var bar = document.querySelector('[data-buybar]');
  var submitBtn = document.querySelector('[data-add-to-cart-form]');
  if (!bar || !submitBtn) return;

  var addBtn = bar.querySelector('[data-buybar-add]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var form = submitBtn.closest('form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    var inView = entries[0].isIntersecting;
    bar.classList.toggle('is-visible', !inView);
    bar.setAttribute('aria-hidden', inView ? 'true' : 'false');
    document.body.classList.toggle('has-buybar', !inView);
  }, { rootMargin: '-60px 0px 0px 0px' });
  io.observe(submitBtn);
})();

/* ---------- Post-login subscribe prompt ---------- */
(function () {
  var KEY = 'thca:subPrompt';
  var store = null;
  try { store = window.localStorage; } catch (e) {}
  function remember() { if (store) { try { store.setItem(KEY, 'dismissed'); } catch (e) {} } }

  // Returning from a Subscribe submit: Shopify redirects back with
  // ?customer_posted=true — show the confirmation toast, then tidy the URL.
  var confirmToast = document.querySelector('[data-sub-confirm]');
  var posted = /(?:\?|&)customer_posted=true/.test(window.location.search);
  if (posted && confirmToast) {
    remember();
    confirmToast.hidden = false;
    setTimeout(function () { confirmToast.classList.add('is-open'); }, 300);
    setTimeout(function () { confirmToast.classList.remove('is-open'); }, 9000);
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      var qs = url.searchParams.toString();
      window.history.replaceState({}, '', url.pathname + (qs ? '?' + qs : '') + url.hash);
    } catch (e) {}
  }

  var box = document.querySelector('[data-sub-prompt]');
  if (!box || posted) return;
  if (store && store.getItem(KEY) === 'dismissed') return;
  box.hidden = false;
  setTimeout(function () { box.classList.add('is-open'); }, 1400);
  // One Subscribe click = never re-ask, even while double opt-in is pending
  // (Liquid still reports the customer as unsubscribed until they confirm).
  box.addEventListener('submit', function () { remember(); });
  box.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sub-dismiss]')) return;
    box.classList.remove('is-open');
    remember();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box.classList.contains('is-open')) {
      box.classList.remove('is-open');
      remember();
    }
  });
})();
